{
  "name": "vro.frontend",
  "version": "v2.5.1",
  "scripts": {
    "ng": "ng",
    "start_w": "ng serve --configuration=winterfell",
    "start_h": "ng serve --configuration=highgarden",
    "start_c": "ng serve --configuration=casterly-rock",
    "start_b": "ng serve --configuration=bear-island",
    "start_dev": "ng serve --configuration=dev",
    "start_qa": "ng serve --configuration=qa",
    "start_prod": "ng serve --configuration=production",
    "start": "ng serve --no-hmr",
    "build": "ng build --aot --output-hashing=all",
    "build_dev": "ng build --configuration=dev",
    "build_prod": "ng build --configuration=production",
    "generate-i18n": "ts-node .\\scripts\\convert-alert-language.ts",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --no-watch --code-coverage",
    "test:headless": "ng test --code-coverage=true --browsers ChromeHeadlessNoSandbox --watch=false",
    "build_version": "node git-version.js",
    "format": "prettier --config .prettierrc './**/*.{ts,html,js}' --write",
    "lint": "ng lint",
    "test-spec": "ng test --include='**/app/pages/home/home-advanced-filter/*.spec.ts' --code-coverage=true",
    "build:stats": "ng build --stats-json",
    "analyze": "webpack-bundle-analyzer dist/vro.frontend/stats.json"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/build-webpack": "^0.1902.12",
    "@angular/animations": "^19.2.10",
    "@angular/cdk": "^19.2.16",
    "@angular/common": "^19.2.10",
    "@angular/compiler": "^19.2.10",
    "@angular/core": "^19.2.10",
    "@angular/forms": "^19.2.10",
    "@angular/material": "^19.2.16",
    "@angular/platform-browser": "^19.2.10",
    "@angular/platform-browser-dynamic": "^19.2.10",
    "@angular/router": "^19.2.10",
    "@azure/msal-angular": "^3.1.0",
    "@azure/msal-browser": "^3.28.1",
    "@fortawesome/angular-fontawesome": "^1.0.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@microsoft/applicationinsights-angularplugin-js": "^15.3.6",
    "@microsoft/applicationinsights-web": "^3.3.7",
    "@microsoft/microsoft-graph-client": "^3.0.7",
    "@ngneat/svg-icon": "^7.1.6",
    "@primeng/themes": "^19.1.2",
    "@types/quill": "^2.0.10",
    "axios": "^1.7.2",
    "buffer": "^6.0.3",
    "date-fns": "^4.1.0",
    "email-validator": "^2.0.4",
    "exceljs": "^4.4.0",
    "fabric": "5.3.0-browser",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "joi": "^17.13.3",
    "jspdf": "^3.0.1",
    "jspdf-autotable": "^5.0.2",
    "jszip": "^3.10.2",
    "lodash": "^4.17.21",
    "moment": "^2.29.4",
    "moment-timezone": "^0.5.37",
    "ngx-image-cropper": "^9.1.5",
    "pdf-lib": "^1.17.1",
    "primeflex": "^3.3.0",
    "primeicons": "^6.0.0",
    "primeng": "^19.1.2",
    "quill": "^2.0.3",
    "rxjs": "^7.4.0",
    "socket.io-client": "^4.6.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.12",
    "@angular-eslint/builder": "^19.4.0",
    "@angular-eslint/eslint-plugin": "^19.4.0",
    "@angular-eslint/eslint-plugin-template": "^19.4.0",
    "@angular-eslint/schematics": "^19.4.0",
    "@angular-eslint/template-parser": "^19.4.0",
    "@angular/cli": "~19.2.12",
    "@angular/compiler-cli": "^19.2.10",
    "@types/date-fns": "^2.5.3",
    "@types/fabric": "^5.3.10",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "~4.0.0",
    "@types/lodash": "^4.14.202",
    "@types/node": "^25.5.2",
    "@typescript-eslint/eslint-plugin": "^8.32.1",
    "@typescript-eslint/parser": "^8.32.1",
    "eslint": "^9.26.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.2",
    "jasmine-core": "~4.3.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "prettier": "^3.1.1",
    "prettier-eslint": "^16.2.0",
    "typescript": "5.5.4",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "browser": {
    "crypto": false,
    "constants": false,
    "fs": false,
    "path": false
  }
}
